import React, { useEffect, useCallback, useState } from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import GreenButton from '../../../../ui/GreenButton';
import Swal from "sweetalert2";
import axios from 'axios'





const Card = styled.div`
  border: 1px solid #e7e7e7;
  border-radius: 8px;
  padding: 16px;
  margin-top: 12px;
`;

const Row = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;

  input, textarea {
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 8px 10px;
  }

  textarea {
    width: 100%;
    min-height: 80px;
    resize: vertical;
    background: #f9f9f9;
  }
`;




const HeaderBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;

  strong {
    color: #444;
    font-weight: 700;
  }
`;




const ActionButton = styled.button`
  padding: 8px 12px;
  border-radius: 5px;
  border: 1px solid #ddd;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: transform .12s ease;
  &:hover { transform: scale(1.03); }
`;

const Input = styled.input`
  width: 150px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
`;

const Select = styled.select`
  width: 150px;
  padding: 0 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 37px;
  margin-left: 5px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Wrapper = styled.div`
  --bg: #fff;
  --bg-soft: #fafafa;
  --line: #eaeaea;
  --text: #373737;
  --muted: #6b6b6b;
  --brand: #ff7a00;
  --brand-weak: #fff2e6;

  max-width: 980px;
  margin: 24px auto;
  background: var(--bg);
  box-shadow: 0 8px 24px rgba(0,0,0,.06);
  border: 1px solid var(--line);
  border-radius: 14px;
  padding: 20px;
`;

const PageTitle = styled.h2`
  margin: 6px 4px 16px;
  font-weight: 800;
  color: var(--text);
  letter-spacing: .2px;
`;

const Section = styled.div`
  border: 1px solid var(--line);
  border-radius: 12px;
  padding: 16px;
  background: var(--bg-soft);
  & + & { margin-top: 16px; }
`;

const SectionTitle = styled.div`
  font-weight: 700;
  color: var(--text);
  margin-bottom: 12px;
`;

const Grid2 = styled.div`
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(2, minmax(0,1fr));
  @media (max-width: 760px) { grid-template-columns: 1fr; }
`;

const Field = styled.label`
  display: flex; flex-direction: column; gap: 6px;
  font-size: 13px; color: var(--muted);
  input, textarea, select {
    border: 1px solid var(--line);
    border-radius: 8px;
    height: 38px;
    padding: 0 12px;
    background: #fff;
    color: var(--text);
    outline: none;
    transition: border-color .15s, box-shadow .15s;
  }
  textarea { height: 96px; padding: 10px 12px; resize: vertical; }
  input:focus, textarea:focus, select:focus {
    border-color: #ffd7b0;
    box-shadow: 0 0 0 3px #fff3e6;
  }
`;

const Actions = styled.div`
  display: flex; gap: 10px; flex-wrap: wrap; margin-top: 8px;
`;

const GhostButton = styled.button`
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid var(--line);
  background: #fff;
  font-weight: 600;
  cursor: pointer;
  transition: transform .12s ease, background .12s ease, border .12s ease;
  &:hover { transform: translateY(-1px); background: #fdfdfd; }
  &:disabled { opacity: .55; cursor: not-allowed; transform: none; }
`;

const FiltersBar = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0,1fr)) auto;
  gap: 10px;
  align-items: end;
  @media (max-width: 900px) { grid-template-columns: repeat(2, minmax(0,1fr)); }
  @media (max-width: 540px) { grid-template-columns: 1fr; }
`;

const TableScroll = styled.div`
  width: 100%;
  overflow-x: auto;
  border: 1px solid var(--line);
  border-radius: 12px;
  background: #fff;
`;

const StyledTable = styled.table`
  width: 100%;
  border-collapse: separate; border-spacing: 0;
  th, td { padding: 12px 14px; font-size: 14px; color: var(--text); }
  thead th {
    position: sticky; top: 0; z-index: 1;
    background: #f6f6f6; color: #4d4d4d; font-weight: 700;
    border-bottom: 1px solid var(--line); text-align: left;
  }
  tbody tr:hover { background: #fffaf5; }
  tbody td { border-bottom: 1px solid #f2f2f2; vertical-align: top; }
  thead th:first-child { border-top-left-radius: 12px; }
  thead th:last-child  { border-top-right-radius: 12px; }
  tbody tr:last-child td:first-child { border-bottom-left-radius: 12px; }
  tbody tr:last-child td:last-child  { border-bottom-right-radius: 12px; }
`;

const Chip = styled.span`
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 8px; border-radius: 999px;
  font-size: 12px; font-weight: 600;
  background: var(--brand-weak); color: var(--brand);
  border: 1px solid #ffd7b0;
`;

const DangerOutline = styled.button`
  padding: 6px 10px;
  border: 1px solid #ffb266;
  background: #fff;
  color: #ff7a00;
  font-weight: 700;
  border-radius: 8px;
  cursor: pointer;
  transition: background .12s ease, transform .12s ease, opacity .12s ease;
  &:hover { background: #fff7f0; transform: translateY(-1px); }
  &:disabled { opacity: .5; cursor: not-allowed; transform: none; }
`;

const EmptyState = styled.div`
  text-align: center; padding: 24px 12px; color: var(--muted);
`;

const Pill = styled.span`
  background: #f1f1f1; border: 1px solid var(--line);
  padding: 6px 10px; border-radius: 999px; font-size: 12px; color: #555;
`;


function toInputLocal(dt = new Date()) {
  // formata para "YYYY-MM-DDTHH:MM" (sem segundos)
  const pad = (n) => String(n).padStart(2, '0');
  const year = dt.getFullYear();
  const month = pad(dt.getMonth() + 1);
  const day = pad(dt.getDate());
  const hour = pad(dt.getHours());
  const min = pad(dt.getMinutes());
  return `${year}-${month}-${day}T${hour}:${min}`;
}

export default function ApontarHorasChamado({ urlApi, tipoAcessoModulo8 }) {



  const id = localStorage.getItem('id');
  const token = localStorage.getItem('token');

  const [descricao, setDescricao] = useState('');
  const [inicio, setInicio] = useState(toInputLocal());       // agora
  const [fim, setFim] = useState(toInputLocal());             // agora





  async function salvarPeriodo() {
    try {
      if (!inicio || !fim) {
        toast.warn('Informe início e fim.');
        return;
      }
      if (new Date(fim) <= new Date(inicio)) {
        toast.warn('Fim deve ser maior que o início.');
        return;
      }

      const body = {
        inicio,                 // "YYYY-MM-DDTHH:mm"
        fim,
        descricao: descricao || '',
        cod_funcionario: id,    // <<< padronizado para o back
      };

      const resp = await fetch(`${urlApi}central-ti/apontar-sem-chamado`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(body)
      });

      if (resp.status === 409) {
        const e = await resp.json().catch(() => ({}));
        toast.error(e.error || 'Período se sobrepõe a outro já registrado.');
        return;
      }

      if (!resp.ok) {
        const e = await resp.json().catch(() => ({}));
        throw new Error(e.error || 'Falha ao salvar.');
      }

      setDescricao('');
      setInicio(toInputLocal(new Date()));
      setFim(toInputLocal(new Date()));


      toast.success('Apontamento registrado.');
    } catch (err) {
      console.error(err);
      toast.error(err.message || 'Erro ao salvar período.');
    }
  }




  const [apontamentos, setApontamentos] = useState([]);
  const hoje = new Date().toISOString().split('T')[0];
  const [dataIni, setDataIni] = useState(hoje);
  const [dataFim, setDataFim] = useState(hoje);
  const [usuario, setUsuario] = useState(Number(id))



  const getListaApontamentos = async () => {
    if (!dataIni || !dataFim) return; // evita 400 do backend

    try {
      const res = await axios.get(`${urlApi}central-ti/ver-apontamentos-geral`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { data_ini: dataIni, data_fim: dataFim, usuario: usuario },
      });

      console.log(res.data)
      setApontamentos(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error("Conexão falhou", err?.response?.data || err?.message || err);
    }
  };







  //---------------------------------------FUNÇÂO DELETAR APONTAMENTO---------------------------------------------------//

  //PopUp de confirmação
  const showPopUp = () => {
    return new Promise((resolve) => {
      Swal.fire({
        title: "Essa ação irá apagar o apontamento, deseja confirma?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        customClass: {
          container: 'custom-swal-container',
        },
      }).then((result) => {
        resolve(result.value); // Resolve a Promise com o valor result.value
      });
    });
  };


  // Deleta os usuários
  const handleDeletarApontamento = async (it) => {
    const userConfirmed = await showPopUp();

    if (!userConfirmed) {
      return;
    }

    try {
      // Tenta realizar a requisição para deletar o usuário
      await axios.delete(`${urlApi}central-ti/deletar-apontamento/${it.ID_APONTAMENTO}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Apontamento deletado com sucesso.");


    } catch (error) {

      toast.error(error);


    }


  };

  const canGerenciar = tipoAcessoModulo8 === 'G';

  return (
    <Wrapper>
      <PageTitle>Apontar Horas Fora do Chamado</PageTitle>

      {/* Seção: Lançamento */}
      <Section aria-label="Lançar período">
        <SectionTitle>Lançar período</SectionTitle>
        <Grid2>
          <Field>
            Início
            <input
              type="datetime-local"
              value={inicio}
              onChange={(e) => setInicio(e.target.value)}
              aria-label="Início do período"
            />
          </Field>
          <Field>
            Fim
            <input
              type="datetime-local"
              value={fim}
              onChange={(e) => setFim(e.target.value)}
              aria-label="Fim do período"
            />
          </Field>
          <Field style={{ gridColumn: '1 / -1' }}>
            Descrição (opcional)
            <textarea
              placeholder="Descreva o que foi feito neste período…"
              value={descricao}
              onChange={(e) => setDescricao(e.target.value)}
              aria-label="Descrição do serviço"
            />
          </Field>
        </Grid2>

        <Actions>
          <GreenButton onClick={salvarPeriodo}>Salvar apontamento</GreenButton>
          <GhostButton
            type="button"
            onClick={() => { setInicio(''); setFim(''); setDescricao(''); }}
          >
            Limpar
          </GhostButton>
        </Actions>
      </Section>

      {/* Seção: Consulta */}
      <Section aria-label="Consultar períodos">
        <SectionTitle style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span>Períodos registrados</span>
          <Pill>Total: {apontamentos?.length ?? 0}</Pill>
        </SectionTitle>

        <FiltersBar>
          <Field>
            Início
            <input
              type="date"
              value={dataIni}
              onChange={(e) => setDataIni(e.target.value)}
            />
          </Field>
          <Field>
            Fim
            <input
              type="date"
              value={dataFim}
              onChange={(e) => setDataFim(e.target.value)}
            />
          </Field>
          <Field>
            Usuário
            <select
              value={usuario ?? "null"}
              disabled={!canGerenciar}
              onChange={(e) => {
                const val = e.target.value;
                setUsuario(val === "null" ? null : val);
              }}
            >
              <option value="null">Todos</option>
              <option value="541">541 - Sivaldo</option>
              <option value="1030">1030 - Wellington</option>
              <option value="9556">9556 - Felipe</option>
              <option value="10152">10152 - João Victor</option>
              <option value="11391">11391 - Nicolas</option>
              <option value="12261">12261 - Giovana</option>
            </select>
          </Field>
          <div />
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
            <GhostButton
              onClick={() => { setDataIni(''); setDataFim(''); setUsuario(null); }}
            >
              Limpar filtros
            </GhostButton>
            <GhostButton onClick={getListaApontamentos} disabled={!dataIni || !dataFim}>
              Buscar
            </GhostButton>
          </div>
        </FiltersBar>

        <TableScroll style={{ marginTop: 12 }}>
          <StyledTable>
            <thead>
              <tr>
                <th>Chamado</th>
                <th>Início</th>
                <th>Fim</th>
                <th>Usuário</th>
                <th style={{ width: 120 }}></th>
              </tr>
            </thead>
            <tbody>
              {(!apontamentos || apontamentos.length === 0) && (
                <tr>
                  <td colSpan={5}>
                    <EmptyState>Nenhum período lançado para os filtros selecionados.</EmptyState>
                  </td>
                </tr>
              )}

              {apontamentos?.map((it) => {
                const naoDeletavel = it.ID_CHAMADO !== null;
                return (
                  <React.Fragment key={it.ID_APONTAMENTO}>
                    <tr>
                      <td>{it.ID_CHAMADO || <em>Sem chamado</em>}</td>
                      <td>{it.DATA_INICIO_FORMATADA}</td>
                      <td>{it.DATA_FIM_FORMATADA}</td>
                      <td>
                        <Chip>
                          {it.COD_FUNCIONARIO} · {it.PRIMEIRO_NOME}
                        </Chip>
                      </td>
                      <td>
                        <DangerOutline
                          type="button"
                          onClick={() => handleDeletarApontamento(it)}
                          disabled={naoDeletavel}
                          title={naoDeletavel
                            ? "Não é possível deletar este período"
                            : "Deletar período"}
                          aria-disabled={naoDeletavel}
                        >
                          Deletar
                        </DangerOutline>
                      </td>
                    </tr>

                    {it.DESC_SERVICO && (
                      <tr className="desc-servico-row">
                        <td colSpan={5} style={{
                          padding: '10px 14px',
                          fontSize: 13,
                          color: '#555',
                          background: '#fffdf9'
                        }}>
                          <strong style={{ color: '#5a5a5a' }}>Serviço:</strong> {it.DESC_SERVICO}
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </StyledTable>
        </TableScroll>
      </Section>
    </Wrapper>
  );

}
